export default function () {
  return [
    {
      title: "Dashboard",
      permission: { resource: 'user', action: '' },
      to: "/dashboard",
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ""
    },
    {
      subMenu: true,
      title: "Users",
      permission: { resource: 'user', action: 'create' },
      htmlBefore: '<i class="material-icons">table_chart</i>',
      items: [
        {
          title: "Users List",
          permission: { resource: 'user', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/users-list",
        },
      ]
    },
    {
      subMenu: true,
      title: "Templates",
      permission: { resource: 'template', action: '' },
      items: [
        {
          title: "Templates List",
          permission: { resource: 'template', action: 'read' },
          htmlBefore: '<i class="material-icons">vertical_split</i>',
          to: "/templates-list",
        },
        {
          title: "New Template",
          permission: { resource: 'template', action: 'create' },
          htmlBefore: '<i class="material-icons">vertical_split</i>',
          to: "/new-template",
        },
      ]
    },
    // {
    //   title: "Resources",
    //   permission: { resource: 'resource', action: 'read' },
    //   htmlBefore: '<i class="material-icons">vertical_split</i>',
    //   to: "/blog-posts",
    // },
    {
      subMenu: true,
      title: "Resources",
      permission: { resource: 'resource', action: 'create', group: 'vibino' },
      htmlBefore: '<i class="material-icons">table_chart</i>',
      items: [
        {
          title: "Resources List",
          permission: { resource: 'resource', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/resources-list",
        },
        {
          title: "New Resources",
          permission: { resource: 'resource', action: 'create' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/new-resource",
        },
      ]
    },
    {
      subMenu: true,
      title: "Accounting",
      permission: { resource: 'user', action: 'create' },
      htmlBefore: '<i class="material-icons">table_chart</i>',
      items: [
        {
          title: "Payments",
          permission: { resource: 'payment', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/payments-list",
        },
        {
          title: "Plans",
          permission: { resource: 'payment', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/plans",
        },
        {
          title: "Referrals",
          permission: { resource: 'payment', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/referrals",
        },
        {
          title: "Coupons",
          permission: { resource: 'payment', action: 'update' },
          htmlBefore: '<i class="material-icons">list</i>',
          to: "/coupons",
        },
      ]
    },

    // {
    //   title: "Add New Post",
    //   htmlBefore: '<i class="material-icons">note_add</i>',
    //   to: "/add-new-post",
    // },
    // {
    //   title: "Forms & Components",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/components-overview",
    // },
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // }
  ];
}

